import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FieldActivityLogModel } from '@core/models/models';
import { getActivityLogDataCell, getTimeItems } from '@core/helper';
import { FieldActivityType } from '@core/models/enums';
import { TimeService } from '@core/services/common/time.service';
import { Subscription } from 'rxjs';
import { ActivityLogType } from '@core/configs';
import { FieldActivityLogController } from './field-activity-log-contoller';
import { EXCREATIONSCREEN, USER_DASHBOARD } from '@core/constants';

@Component({
  selector: 'caremoni-field-activity-log',
  templateUrl: './field-activity-log.component.html',
  styleUrl: './field-activity-log.component.scss'
})
export class FieldActivityLogComponent implements OnInit, OnDestroy {

  @Input() data: any[] = [];
  @Input() config: FieldActivityLogModel = new FieldActivityLogModel();
  @Input() controler: any;
  separateDays: boolean = false;
  isShowTimePointer: boolean = true;

  groupedItems: any = {};
  
  widthRedLine = 3
  defaultRows: number = 3;

  widthHeightDefault: string = '100%';
  
  currentTime:any = null;
  timeSub!: Subscription;
  redLineSub!: Subscription;
  postionGridSub!: Subscription;
  timeControllerSub!: Subscription;
  
  iTemsPerInterval = 0; 
  positionGrid = 0;
  postionRedLine = 0;
  timeItems:any = []
  paddingItem = 0;
  width = '100%';
  styleBlock:any = {};
  EXCREATIONSCREEN = EXCREATIONSCREEN;
  styleArray: any[] = [];
  constructor(
    private timeService: TimeService,
    private controller: FieldActivityLogController
  ){}

  ngOnDestroy(): void {
    //unsubscribe to events
    if (this.timeSub) this.timeSub.unsubscribe();
    if(this.redLineSub) this.redLineSub.unsubscribe();
    if(this.postionGridSub) this.postionGridSub.unsubscribe();
    if(this.timeControllerSub) this.timeControllerSub.unsubscribe();
  }

  ngOnInit(): void {
    if (this.data?.length > 0) {
      this.data = this.data?.filter(item => item?.type != FieldActivityType.ELAPSED_TIME);
    }
    if(this.config) {
      this.isShowTimePointer = this.config?.isShowTimePointer ?? true;
      this.separateDays = this.config?.separateDays ?? false;
      this.timeItems = getTimeItems(this.config, this.timeService.getCurrentTime());
      this.generateCellStyle();
      
      const totalMinutes = this.config.interval * 60; 
      this.iTemsPerInterval = Math.round(totalMinutes / this.config.timeInterval); 
      
      this.groupItemsByRange();
      
      this.width = `${this.timeItems.length  * 100/this.config.segmentNum}%`

      if(!this.config.rows) this.config.rows = this.defaultRows;
      if(!this.config.width) this.config.width = this.widthHeightDefault;
      if(!this.config.height) this.config.height = this.widthHeightDefault;
      const screen = Array.isArray(this.data) ? this.data[0]?.screen : null;

      if (screen === EXCREATIONSCREEN.EXCREATION) {
        this.styleBlock = { height: '25%' };
      } else if (screen === USER_DASHBOARD.SCREEN_ALIAS) {
        this.styleBlock = { height: '45%' };
      } else {
        const defaultHeight = this.config.type === ActivityLogType.LogCurrent ? '50%' : '33%';
        this.styleBlock = { height: defaultHeight };
      }
    }

    //init controller
    this.controller.setConfig(this.config);

    //init positionGrid
    let endhours = this.controller.getEndTime(this.timeService.getCurrentTime(), this.config)
    let potionGrid = this.controller.getPostionGrid(this.timeService.getCurrentTime(),  this.config, endhours);
    this.positionGrid  = potionGrid;
    //init postionRedLine
    this.postionRedLine =  this.controller.getPosionReadLine(this.timeService.getCurrentTime(), this.config)
    
    //subscribe to events
    this.timeSub =  this.timeService.getCurrentTimeStrSubject().subscribe(time => this.currentTime = time);
    this.redLineSub = this.controller.getChangeRedLine().subscribe(this.onRedLinePositionChange.bind(this));
    this.postionGridSub = this.controller.getChangePositionGrid().subscribe(this.onGridPositionChange.bind(this));
    this.timeControllerSub =  this.controller.getChangeTime().subscribe(this.onTimeChange.bind(this));
  }

  onRedLinePositionChange(postion: any) {
    if (postion != null)
      this.postionRedLine = postion
    
  }
  
  onGridPositionChange(postion: any) {
    if (postion != null)
      this.positionGrid = postion
    
  }

  generateCellStyle() {
    this.styleArray = [];
    if(!this.separateDays) {
        this.timeItems.forEach((item: any) => this.styleArray.push())
        return;
    }

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    let prevDateIndex = -1;

    for (let i = this.timeItems.length - 1; i >= 0; i--) {
        if (this.timeItems[i] < todayStart) {
            prevDateIndex = i;
            break;
        }
    }

    this.timeItems.forEach((value: number, colIndex: any) => {
      let style: any = {};
      if(colIndex > prevDateIndex)
        style = this.generatePrevDateBackground();
      this.styleArray.push(style);
    });
  }

  generatePrevDateBackground() {
    return {
        backgroundColor: '#1E222E'
    };
  } 

  onTimeChange(time: any) {
    this.timeItems = getTimeItems(this.config, this.timeService.getCurrentTime());
    this.generateCellStyle();
    this.groupItemsByRange();
  }

  groupItemsByRange(): void {
    this.groupedItems = [];
    this.timeItems.map((timeItem: any) => {
      let dataTime :any = {};
      dataTime.time = timeItem;
      dataTime.grid = [];
      let slots = this.config.interval * 60 / this.config.timeInterval;

      let data = getActivityLogDataCell(this.data, timeItem, this.config);

      for (let column = 0; column < slots ;column++) {
        let datacolumn = data.filter((cell: any) => cell.column == column);
        const fixedRowItems = this.getFixedRowItems(datacolumn);
        if (fixedRowItems) {
          dataTime.grid[column] = fixedRowItems;
          continue;
        }

        for(let i = 0; i < datacolumn.length; i++) {
          (dataTime.grid[column] ||= []) [i] = datacolumn[i];
        }
        
        let itemEmptyCout = (this.config.rows??0) - datacolumn.length
        if(itemEmptyCout > 0) {
          for(let i = 0; i < itemEmptyCout; i++) {
            (dataTime.grid[column] ||= []) [i + datacolumn.length] = null;
          }
        }
      }
      this.groupedItems.push(dataTime);
    })
  }

  private getFixedRowItems(items: any[]): any[] | null {
    const rowGroups = this.getFixedActivityTypeRowGroups();
    if (!rowGroups) return null;
    if (items.length === 0) return null;

    const rows: any[] = [];
    for (const rowGroup of rowGroups) {
      const itemsInGroup = this.getItemsInActivityTypeOrder(items, rowGroup); // split into these group

      for (let rowIndex = 0; rowIndex < rowGroup.length; rowIndex++) { // push item in a group that it belong to (example ==> medicine is group one will always on top)
        rows.push(itemsInGroup[rowIndex] ?? null);
      }
    }

    return rows;
  }

  private getFixedActivityTypeRowGroups(): number[][] | null {
    const rowGroups = (this.config as any)?.fixedActivityTypeRowGroups;
    return Array.isArray(rowGroups) && rowGroups.length > 0 ? rowGroups : null;
  }

  private getItemsInActivityTypeOrder(items: any[], activityTypeOrder: number[]): any[] {
    return items
      .filter((item: any) => activityTypeOrder.includes(item?.item?.type))
      .sort((left: any, right: any) => {
        return activityTypeOrder.indexOf(left?.item?.type) - activityTypeOrder.indexOf(right?.item?.type);
      });
  }

  getItemClass(colIndex: number, id: number) {
    const isExcreation = this.data?.[0]?.screen === EXCREATIONSCREEN.EXCREATION;
    const grid = this.groupedItems?.[colIndex]?.grid?.[id];
    const length = grid?.length || 0;

    return {
      'icon-scale': isExcreation && length <= 2
    };
  }

  getItemStyle(colIndex: number, id: number) {
    const isExcreation = this.data?.[0]?.screen === EXCREATIONSCREEN.EXCREATION;
    const grid = this.groupedItems?.[colIndex]?.grid?.[id];
    const length = grid?.length || 0;

    if (!isExcreation || length === 0) return {};

    return {
      height: `${100 / length}%`
    };
  }
}
